<!--
 * @Description: 组织事务
 * @Author: PF
 * @Date: 2023-12-11 16:50:24
 * @LastEditors: PF
 * @LastEditTime: 2023-12-11 17:54:55
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">组织事务</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column type="index" label="序号" align="center" width="80" />
              <el-table-column label="事务类型" prop="zzswlxmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="组织类型" prop="zzlx.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="事务名称" prop="zzswmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="开始日期" prop="ksrq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="结束日期" prop="jsrq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="状态" prop="zt.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="备注" prop="bz" align="center" />
              <el-table-column label="附件" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="fuJianClick(scope.row)">预览</span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="180" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" v-if="scope.row.zt.value===cyrytjztData.weitijiao" @click="openShiWuChuLi=true;tcRow={dbgzid:scope.row.id}">提交作品</el-button>
                  <el-button link type="primary" v-if="scope.row.zt.value===cyrytjztData.yitijiao" @click="openShiWuYuLan=true;tcRow=scope.row">预览作品</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="ruleForm" />
  <shiwuchuli v-if="openShiWuChuLi" v-model:openShiWuChuLi="openShiWuChuLi" :row="tcRow" @ReturnData="bindTable()" />
  <shiwuyulan v-if="openShiWuYuLan" v-model:openDetail="openShiWuYuLan" :row="tcRow" @ReturnData="bindTable()" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  homeCloseWindow,
  actionPost
} from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { getCyrytjzt } from '@/utils/meiju'
import pagination from '@/components/pagination.vue'
import fujian from '@/components/fujian.vue'
import shiwuchuli from '@/components/home/daibanshixiang/shiwuchuli/list.vue' // 事务处理
import shiwuyulan from '@/components/home/daibanshixiang/shiwuchuli/detail.vue' // 事务处理

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const ruleForm = ref({ listFj: [] })
const fuJianClick = (row) => {
  actionPost({ url: '/api/v2/zuzhi/zuzhishiwu/canyurenyuanfujianyulan/' + row.id, data: {} }).then((res) => {
    if (res.code === 200) {
      ruleForm.value.listFj = res.data.listFjCyry || []
      openFuJian.value = true
    } else {
      warningPrompt(res.message)
    }
  })
}

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'ksrq', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/zuzhi/zuzhishiwu/wodezuzhishiwu',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const tcRow = ref({})
const openShiWuChuLi = ref(false)
const openShiWuYuLan = ref(false)
const openFuJian = ref(false)
const openList = ref(false)

const cyrytjztData = ref()
watch(
  () => props.open,
  () => {
    if (props.open === 'zuzhishiwu') {
      openList.value = true
      cyrytjztData.value = getCyrytjzt()
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
